export default {
    UserPoolId: 'ap-southeast-2_n5qgs9u45',
    ClientId: '65k3nad5etrab924o1vl0rs9cv',
  };


// WEBPACK FOOTER //
// ./src/services/AWSCognito/config.ts